import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoxQuestionnaireStatus } from '../../enums';
import { BoxQuestionnaireStatusPipe } from '../../pipes';

@Component({
  selector: 'app-box-questionnaire-status',
  imports: [CommonModule, BoxQuestionnaireStatusPipe],
  templateUrl: './box-questionnaire-status.component.html',
  styleUrl: './box-questionnaire-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxQuestionnaireStatusComponent {
  public readonly status = input.required<BoxQuestionnaireStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case BoxQuestionnaireStatus.Pending:
        return 'text-amber-500';

      case BoxQuestionnaireStatus.Filled:
        return 'text-emerald-700';

      case BoxQuestionnaireStatus.Ended:
        return 'text-gray-500';

      default:
        return '';
    }
  });
}
